import request from '@/utils/httpRequest'
/*
 * @author: xz
 * @date: 2022/08/02
 * */
/*
 * @Description: 文旅企业列表
 * */
export function getEnterpriseList (query) {
  return request({
    url: '/api/culture/web/culturalTourismCompany/page',
    method: 'get',
    params: query
  })
}
/*
 * @Description: 文旅企业详情
 * */
export function getEnterpriseDetail (id) {
  return request({
    url: '/api/culture/web/culturalTourismCompany?id=' + id,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/enterprise/index.js